import axios from 'axios'
import decryptData from '@/store/auth/decryptData'

export default {
  namespaced: true,
  state: () => ({
    assignList: [],
    assignListLoaded: false,
  }),
  mutations: {
    SET_ASSIGNLIST(state, assign) {
      state.assignList = assign
      state.assignListLoaded = true
    },
  },
  actions: {
    async fetchAssignList({ commit, state }) {
      if (!state.assignListLoaded) {
        const res = await axios.get(
          'https://gulftic-system.fci.group/api/task/assign-list',
        )
        const allAssignedTo = decryptData(res.data.payload)?.data
        const formatted = allAssignedTo
          ? allAssignedTo.map(item => ({
            label: `${item.name} - ${item.email}`,
            value: {
              id: item.id,
              type: item.type,
            },
          }))
          : []
        commit('SET_ASSIGNLIST', [...formatted])
      }
    },
  },
  getters: {
    assignList: state => state.assignList,
    assignListLoaded: state => state.assignListLoaded,
  },
}
